export default class LoginInput {
    constructor () {
      this.email = null
      this.senha = null
    }
  }